import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ['tag']

  connect() {
    console.log("Hello, Stimulus!", this.element)
  }

  select_tag() {
    let filterProductFrom = document.getElementById('filter-product-form')
    Rails.fire(filterProductFrom, 'submit')
  }
}
